<template>
  <div>
    {{ showopenmodalcomp }}
    <div v-if="showopenmodalreciept">
      <!-- template for the modal component -->
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div
              class="modal-dialog modal-md"
              style="display: block !important"
            >
              <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header pb-0">
                  <h5
                    class="modal-title text-center pull-left w-100 d-block mt-4 pb-0"
                  >
                    Clinical Reports
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="cancelAction()"
                  >
                    <i class="material-icons">close</i>
                  </button>
                </div>
                <!-- Modal body -->
                <div class="modal-body m-0 px-5">
                  <div v-if="showspinner">
                    <div class="processing_popup full-spinner" style="visibility: visible;">
                        <div class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce2"></div>
                            <div class="bounce3"></div>
                        </div>
                    </div>
                </div>
                  <div>
                     <div class="calender-input">
                        <input type="text" class="date w-100" id="start_date" autocomplete="off" name="uname" required v-model="start_date">
                    </div> 
                    <div class="text-center mt-2">
                      <slot name="footer">
                        <button style="float:none;"
                        :disabled="showspinner"
                          type="button"
                          class="primary-btn ripple"
                          @click="downloadReport"
                        >
                          Download
                        </button>
                      </slot>
                    </div>
                  </div>                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    
    <!-- <transition name="fade"> -->
    <Messages
      v-if="isdisplaymsg"
      v-bind:datamessage="sucessmsgtext"
      v-bind:iserror="iserrormsg"
      v-on:closemsg="closeMessage"
      v-bind:isVisible="isdisplaymsg"
    ></Messages>
    <!-- </transition> -->
  </div>
</template>


<script>
import rest_service from "@/api/rest_service";
import Axios from "axios";
import Messages from "@/components/MessagePopup/Messages";
import flatpickr from "flatpickr";
import confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate';
import moment from "moment";
import Vue from "vue";
import * as XLSX from 'xlsx';

import { mapActions, mapGetters, Store } from "vuex";
var fltstrtDPckr = null; 
const suburl = "/appointment";
export default {
  name: "ClinicalReposrts",
  props: ["showmodalreceipt", "parentpropreceipt"],
  components: { Messages },
  data() {
    return {
      //For Messages popup
      isdisplaymsg: false,
      sucessmsgtext: "",
      iserrormsg: false,
      showopenmodalreciept: false,
      start_date: moment().format("YYYY-MM-DD"),
      StartDateChange:null,
      loggedInUser: null,
      showspinner: false,
      prevSelected: "1",
     
    };
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      "ac_get_tenant"
    ]),
     initializeFlatPicker() {
      const todaysdate = moment().format("YYYY-MM-DD");

      if (this.fltstrtDPckr) {
        this.fltstrtDPckr.destroy();
      }

      this.fltstrtDPckr = flatpickr(
        document.getElementById("start_date"),
        {
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d",
          defaultDate: todaysdate,
          maxDate: "today"
        }
      );
    },
    
	 downloadReport() {
      this.showspinner = true;
       this.isdisplaymsg=false;
      var api_url = rest_service.baseURL + "/appointment/export-appointments";
      
      Axios.request({
        method: "get",
        url: api_url,
        headers: {
          x_tenant_id: localStorage.tenantid,
          role_unique_id: this.loggedInUser.role.unique_id,
          route_entity_name: suburl,
          loggedin_user_unique_id: this.loggedInUser.unique_id,
          Authorization: localStorage.accesstoken,
        },
        params: {
          tenantId: localStorage.tenantid,
          date: moment(this.start_date).format("YYYY-MM-DDTHH:mm:ss")
        },
         timeout: 120000
      })
        .then((response) => {
          this.showspinner = false;
          
          console.log("Received data:", response.data);
          
          const appointments = response.data;
          
          if (!appointments || appointments.length === 0) {
            this.isdisplaymsg=true;
            this.iserrormsg=true;
            this.sucessmsgtext="No appointments found for the selected date.";
            setTimeout((xy)=>{this.closeMessage();},this.$store.state.helper.msgDisplayTime);
            return;
          }
          debugger
          this.generateExcelFile(appointments);
        })
        .catch((ex) => {
          this.showspinner = false;
          this.isdisplaymsg=true;
            this.iserrormsg=true;
          
          if (ex.response) {
            this.sucessmsgtext="Server error: " + (ex.response.data.message || "Unknown error");
          } else if (ex.request) {
             this.sucessmsgtext="No response from server. Please check your connection.";
          } else {
             this.sucessmsgtext="Error: " + ex.message;
          }
          setTimeout((xy)=>{this.closeMessage();},this.$store.state.helper.msgDisplayTime);
        });
    },

    generateExcelFile(data) {
      const formattedData = data.map(appointment => ({
        'Token No': appointment.tokenId || '-',
        'Registration No': appointment.registrationNo || '',
        'Patient Name': this.formatRegId(appointment.patientName) || '',
        'Gender': appointment.gender
          ? appointment.gender.charAt(0).toUpperCase() + appointment.gender.slice(1).toLowerCase()
          : '',
        'Contact Number': appointment.contactNumber || '',
        'Appointment Time': this.formatTimeToIST(appointment.appointmentTime) || '',
        'Date': this.formatDate(appointment.date),
        'Diagnosis': appointment.diagnosis || '',
        'Current Nature': appointment.currentNature || '',
        'Original Nature': appointment.originalNature || '',
        'Medicines': appointment.medicines || '',
        'Suggestions': appointment.suggestions || '',
        'Status': appointment.statusName || ''
      }));
      
      // Create workbook
      const workbook = XLSX.utils.book_new();
      
      // Convert to worksheet
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      
      // Set column widths for better readability
      worksheet['!cols'] = [
        { wch: 12 },  // Token ID
        { wch: 18 },  // Registration No
        { wch: 25 },  // Patient Name
        { wch: 10 },  // Gender
        { wch: 18 },  // Contact Number
        { wch: 18 },  // Appointment Time
        { wch: 15 },  // Date
        { wch: 30 },  // Diagnosis
        { wch: 25 },  // Current Nature
        { wch: 35 },  // Medicines
        { wch: 35 },  // Suggestions
        { wch: 15 }   // Status
      ];
      
      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
      
      // Generate filename with formatted date
      const filename = `Appointments_${moment(this.start_date).format('DD-MM-YYYY')}.xlsx`;
      
      // Write file
      XLSX.writeFile(workbook, filename);
    },
    formatRegId(value) {
      if (!value) return "";

      return value.replace(/-(\d+)/, (match, digits) => {
        return "-" + digits.padStart(4, "0");
      });
    },
    formatTimeToIST(time) {
      if (!time) return '';

      const date = moment.utc(time, [
        moment.ISO_8601,
        'hh:mm A',
        'HH:mm'
      ]);

      if (!date.isValid()) return time;

      return date.local().format('hh:mm A');
    },

    cancelAction() {
      this.showopenmodalreciept = false;
      this.parentpropreceipt.opencloseclinicalreport = false;
    },
    formatDate(dateValue) {
      if (!dateValue) {
        return '';
      }

      if (typeof dateValue === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(dateValue)) {
        return dateValue;
      }

      const parsedDate = moment(dateValue);

      if (parsedDate.isValid()) {
        return parsedDate.format('DD-MM-YYYY');
      }

      const formats = [
        'YYYY-MM-DD',
        'DD/MM/YYYY',
        'MM/DD/YYYY',
        'YYYY-MM-DDTHH:mm:ss',
        'YYYY-MM-DDTHH:mm:ss.SSSZ',
        moment.ISO_8601
      ];

      for (let format of formats) {
        const attemptParse = moment(dateValue, format, true);
        if (attemptParse.isValid()) {
          return attemptParse.format('DD-MM-YYYY');
        }
      }

      // If all parsing fails, log the value and return empty or original value
      console.warn('Could not parse date:', dateValue);
      return dateValue.toString(); // Return as string so you can see what the actual value is
    },
    
    closeMessage() {
      this.isdisplaymsg = false;
    },
    
  },
  created() {
    if (this.$store.state.helper.tenant_id) {
      this.ac_get_tenant(this.$store.state.helper.tenant_id);
    }
    this.loggedInUser = JSON.parse(localStorage.loggedInUserInfo);
    //this.getSettings();
  },
  computed: {
    showopenmodalcomp() {
      var self = this;
      self.showopenmodalreciept = self.showmodalreceipt;
    },
  },
  watch: {
   showopenmodalreciept(val) {
    if (val) {
      this.$nextTick(() => {
        this.initializeFlatPicker();
      });
    } else {
      if (this.fltstrtDPckr) {
        this.fltstrtDPckr.destroy();
        this.fltstrtDPckr = null;
      }
    }
  }
  },
};
</script>

<style scoped>
.radio-container {
  width: auto !important;
  margin-left: 15px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-container.modal-width500 {
  max-width: 650px;
  width: 100%;
}
.modal-container.modal-width500 .modal-header {
  border-bottom: 1px solid transparent !important;
  padding-bottom: 0px !important;
}
.modal-container.modal-width500 .modal-footer {
  border-top: 1px solid transparent !important;
}
.modal-container.modal-width500 .modal-header {
  min-height: 10px !important;
}
.modal-container.modal-width500 .modal-body {
  margin: 0px !important;
}
.select .sector-select {
  color: #000 !important;
}
.category-select-default.single .select-txt {
  position: relative;
  z-index: 999999999;
  top: -45px;
  display: block;
  color: #000 !important;
  width: 90%;
  height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.category-select-default.single .select-txt {
  color: #777;
}
input[type="checkbox"],
input[type="radio"] {
  height: 19px !important;
  width: 100%;
  left: 0px;
  z-index: 1;
}
/* Fix floating label overlap with flatpickr */
.container-comm {
  position: relative;
}

.container-comm label {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  background: #fff;
  padding: 0 6px;
  font-size: 14px;
  color: #888;
  pointer-events: none;
  transition: all 0.2s ease;
}

/* When flatpickr input has value */
.container-comm input:not(:placeholder-shown) + label,
.container-comm input.flatpickr-input + label {
  top: -6px;
  font-size: 12px;
  color: #555;
}

</style>